import { Flex } from "@chakra-ui/react";
import "./App.css";
import RequestDemo from "./pages/RequestDemo";

function App() {
  return (
    <>
      <Flex
        direction="column"
        justify="center"
        align="center"
        alignItems="flex-start"
        justifyContent="center"
        h="full"
        p={6}
        minHeight="100vh"
      >
        <RequestDemo />
      </Flex>
    </>
  );
}

export default App;
